import $ from 'jquery';
import constants from 'Constants';
import listService  from 'ListService';
import BasePropertyView from 'BasePropertyView';
import nameTemplate from 'properties/main/name.ejs';
import eventBus  from 'EventBus';
import pageCollection from 'PageCollection';
import mobileFactoryService from 'mobile/MobileFactoryService';

const SILENT = constants.MODEL_SILENT;
import undoService from 'UndoService';
import factoryService   from 'FactoryService';
import mobileSyncService from '../../service/mobile/MobileSyncService';
import util from 'util/Util';

class MainNameView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };
        
        this.collection = pageCollection;

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const breadCrumbType = this.model.get('factoryKey')==='page_instance' ? 'PAGE' : 'OBJECT';

        let oldVal = this.model.get(propName); 
 
		if (propVal.toString() !== oldVal.toString()) {
			
			this.updateNames(breadCrumbType, propVal);
			
			this.model.set( propName, propVal, constants.MODEL_SILENT );
            mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

			this.render();

    	    eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
            undoService.add({
                undo: () => {
                    this.model.set(propName, oldVal);
                    this.updateNames(breadCrumbType, oldVal);
                    this.render();
                    eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, breadCrumbType, this.model.get('id'));
                },
                redo:() => {
                    this.model.set(propName, propVal);
                    this.updateNames(breadCrumbType, propVal);
                    this.render();   
                    eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, breadCrumbType, this.model.get('id'));      
                }
            }, constants.UNDO_PROP_CHANGE);

            eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, breadCrumbType, this.model.get('id'));
            eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
		}
    }
    
    updateNames(breadCrumbType, propVal){
        if (breadCrumbType === 'PAGE') {

            this.model.set({'pageTitle':  propVal, 'name': propVal}, constants.MODEL_SILENT);

            let filteredPage = this.collection.filter(p => p.get('id') === this.model.get('id') );
            filteredPage[0].set('name', propVal, SILENT);
            filteredPage[0].set('pageTitle', propVal, SILENT);

            // Rename thumbnail page item
            eventBus.trigger(constants.EV_RENAME_PAGE, this.model.get('id'), propVal);

            // PF-5491 change name of page also in navigation tab
            const thumbListView = listService.getMainView(constants.KIND_THUMBLIST);
            thumbListView.updatePageName(this.model.get('id'), propVal);
        } else {
            const id = this.model.get('id');
            let filteredPage  = this.collection.filter(function(e) {
                return e.get('objects').some(function(a) {
                  return a.id === id
                })
              });
            if (filteredPage.length) {
                let objArray = filteredPage[0].get('objects');
                const objIndex = objArray.findIndex(obj => obj.id === this.model.get('id') );
                objArray[objIndex].name = propVal;
                filteredPage[0].set('objects', objArray, SILENT);
            }

            $('#objects-page-' + listService.currentPageId + ' ul > li[data-id="' + this.model.get('id') + '"] > a >span').contents().first()[0].textContent = propVal;
            let tooltip = $('#objects-page-' + listService.currentPageId + ' ul > li[data-id="' + this.model.get('id') + '"] > a')[0];
            const factoryName = factoryService.factories[this.model.get('factoryKey')].name;
            const tooltipName = factoryName + ': ' + propVal;
            $(tooltip).prop('title', tooltipName);
            /*
            * This block of code comes directly from Matty's branch PF-4918.
            * I just included the source from mobile Factory.
            * */
            if (listService.mainKind === constants.KIND_MOBILE ) {
                $('#objects-page-' + listService.currentPageId + ' ul > li[data-id="' + this.model.get('id') + '"] > a >span').contents().first()[0].textContent = propVal;
                let tooltip = $('#objects-page-' + listService.currentPageId + ' ul > li[data-id="' + this.model.get('id') + '"] > a')[0];
                let factoryKey = this.model.get('factoryKey');
                const factoryName = listService.mainKind === constants.KIND_MOBILE ?
                    mobileFactoryService.factories[factoryKey].name : factoryService.factories[factoryKey].name;
                const tooltipName = factoryName + ': ' + propVal;
                $(tooltip).prop('title', tooltipName);
            }
        }

    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }


}

export default MainNameView;
